import React, { useMemo } from "react";

const HeaderCell = (props) => {
    const { field, setData, ascending, setAscending, dataGrid, headerStyles, selectedField, setSelectedField, isDataDashboard, sorteable } = props;

    let iconFilter = useMemo(() => {
        if (selectedField === props.title) {
            return ascending ? "k-i-sort-asc-sm" : "k-i-sort-desc-sm";
        }
        return "";
    }, [ascending, selectedField, props.title]);

    const handleSort = () => {

        if (!sorteable) return

        let newAscending = ascending;

        selectedField !== props.title ? newAscending = true : newAscending = !ascending;

        const result = [...dataGrid].sort((a, b) => {
            const isNumeric = !isNaN(parseFloat(a[field])) && isFinite(a[field]);

            if (isNumeric) {
                return newAscending ? parseFloat(a[field]) - parseFloat(b[field]) : parseFloat(b[field]) - parseFloat(a[field]);
            } else {
                if (a[field] < b[field]) {
                    return newAscending ? -1 : 1;
                }
                if (a[field] > b[field]) {
                    return newAscending ? 1 : -1;
                }
                return 0;
            }
        });
        setSelectedField(props.title);
        setAscending(newAscending);

        //Si es el dashboard de un ticket en especifico de un cliente 
        if (isDataDashboard?.dashboardData1) {
            setData({
                dashboardData1: isDataDashboard.dashboardData1,
                dashboardData2: isDataDashboard.dashboardData2,
                ticketsData: [...result]
            });
            //Si es el dashboard de la pagina inicial
        } else if (isDataDashboard?.dashboardData) {
            setData({
                dashboardData: isDataDashboard.dashboardData,
                clientsData: [...result]
            });
            //Si no es el dashboard
        } else {
            setData([...result]);
        }

    }
    return <span onClick={() => handleSort()} style={headerStyles}>{props.title} {selectedField === props.title ? <i className={`k-icon ${iconFilter}`}></i> : ("")}</span>;
};

export default HeaderCell;
